import React from "react";
import * as W from "./WarningComunicadoStyle2";
import { FaShieldAlt } from "react-icons/fa";

export default function WarningComunicado({ onClose }) {
  return (
    <W.WarningOverlay>
      <W.WarningContainer>
        <W.TopAccent />

        <W.Header>
          <W.IconCircle>
            <FaShieldAlt />
          </W.IconCircle>
          <W.Badge>Comunicado</W.Badge>
          <W.Title>Comunicado aos Clientes</W.Title>
          <W.Divider />
        </W.Header>

        <W.Body>
          <W.TextContent>
            <p>Prezado(a) Cliente,</p>

            <p>
              A Golden Brasil pauta sua trajetória pela transparência absoluta
              com seus parceiros. Por este motivo, escrevemos para informá-los
              sobre os recentes desafios enfrentados por nossa gestão e sobre
              as medidas que vêm sendo adotadas para a regularização da nossa
              operação.
            </p>

            <p>
              <strong>1. Transparência sobre Desvios</strong>
            </p>
            <p>
              Identificamos divergências relacionadas a pagamentos realizados
              em nossa estrutura interna. Após auditoria preliminar,
              constatou-se que parte dessas ocorrências decorreu de
              procedimentos adotados pela gestão anterior e parte envolveu
              situações em que determinados clientes receberam ou buscaram
              receber valores superiores aos previstos contratualmente,
              matéria atualmente em processo de apuração e regularização.
            </p>
            <p>
              Gostaríamos de enfatizar que todas as medidas administrativas,
              jurídicas e de compliance já foram adotadas para apurar os
              fatos, corrigir as inconsistências identificadas e fortalecer
              nossos controles internos, assegurando maior rigor, transparência
              e conformidade em todas as operações da empresa.
            </p>

            <p>
              <strong>2. O Lastro da Operação: Ativos Reais</strong>
            </p>
            <p>
              É fundamental destacar que, apesar deste contratempo
              administrativo, a solidez patrimonial da empresa permanece
              preservada. O que diferencia a Golden Brasil de qualquer
              estrutura especulativa é o nosso lastro em ativos reais.
            </p>
            <p>
              A empresa mantém, sob sua titularidade e administração, reservas
              minerais (pedras preciosas, diamantes, joias, minérios diversos,
              títulos da Petrobras, máquinas e equipamentos), bem como
              propriedades e ativos imobiliários. Trata-se de patrimônio
              físico e auditável, que permanece integralmente vinculado à
              empresa e que constitui a base material da sua atividade.
            </p>

            <p>
              <strong>3. Plano de Regularização</strong>
            </p>
            <p>
              Estamos trabalhando intensamente na conclusão dos trabalhos de
              auditoria e na reorganização do nosso fluxo de caixa. Para que
              todos tenham clareza sobre as etapas em curso, apresentamos o
              nosso calendário de trabalho:
            </p>

            <W.Highlight>
              <p>
                <strong>Conclusão da auditoria:</strong> até o final de agosto
                de 2026.
              </p>
              <p>
                <strong>Apresentação do plano de regularização:</strong> até o
                final de setembro de 2026.
              </p>
            </W.Highlight>

            <p>
              Concluída a auditoria, a empresa apresentará, até o final de
              setembro, o plano de regularização contendo o cronograma de
              pagamentos, elaborado a partir da posição consolidada e
              individualizada de cada contrato. As datas acima referem-se às
              etapas que dependem exclusivamente da empresa, razão pela qual
              podem ser informadas com segurança desde já.
            </p>
            <p>
              Registramos, ainda, que a empresa não promoverá alienação de
              ativos à revelia dos procedimentos legais, contábeis e de
              governança aplicáveis.
            </p>

            <p>
              <strong>4. Sobre Informações Inverídicas em Circulação</strong>
            </p>
            <p>
              Não corresponde à verdade a afirmação de que os administradores
              da empresa tenham deixado o país, de que a empresa tenha
              encerrado suas atividades ou de que tenha havido apropriação de
              recursos. A empresa mantém sede, estrutura administrativa e
              quadro de colaboradores em funcionamento regular, e seus
              administradores permanecem no exercício de suas funções, em
              território nacional.
            </p>
            <p>
              Solicitamos que todo esclarecimento seja buscado exclusivamente
              pelos canais oficiais, únicos meios pelos quais a empresa presta
              informação sobre a situação individual de cada contrato.
            </p>
            <p>
              Registramos, com preocupação, que colaboradores têm sido
              procurados em caráter pessoal, com abordagens hostis e ameaças.
              Esses profissionais não detêm poder de decisão sobre pagamentos,
              saques ou cronogramas. Independentemente de qualquer divergência
              quanto à situação contratual, tais condutas podem configurar
              ilícito penal, e a empresa adotará as providências cabíveis para
              proteger sua equipe.
            </p>

            <p>
              <strong>5. Conclusão</strong>
            </p>
            <p>
              Problemas de gestão podem ocorrer em qualquer grande corporação,
              e o que define a consistência de uma operação é o que está por
              trás dela. Na Golden Brasil o que sustenta a atividade não são
              apenas números em uma tela, mas pedras preciosas, minérios,
              terras e produção mineral real.
            </p>
            <p>
              Agradecemos a compreensão e a paciência neste momento de
              transição. Nossa diretoria permanece à disposição para
              esclarecimentos e reafirma o compromisso com a condução
              responsável e transparente deste processo.
            </p>

            <p>Atenciosamente,</p>
            <p>
              <strong>Golden Brasil</strong>
            </p>
          </W.TextContent>
        </W.Body>

        <W.Footer>
          <W.AcceptButton onClick={onClose}>Estou ciente</W.AcceptButton>
        </W.Footer>
      </W.WarningContainer>
    </W.WarningOverlay>
  );
}
